(function(){
    'use strict';

    angular.module('elogbooks.user.bulk-actions', []);
})();
